import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LookupService } from 'src/app/services/lookup-data.service';
import { USER_PERMISSIONS } from 'src/app/data/constants/permissions';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { select, Store } from '@ngrx/store';
import { updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { getSubTaskDetails } from '../../store/selectors/sub-task-details.selectors';
import { ServiceCenterDetails, SignatoryDetails, SubTaskDetails } from 'src/app/data/models/subTaskDetails.model';
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { ToastrService } from 'ngx-toastr';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomQuestionnaireService } from 'src/app/modules/custom-questionaire/services/custom-questionnaire.service';
import { StepTaskAllocationComponent } from 'src/app/modules/task-allocation/step-task-allocation/step-task-allocation.component';

@Component({
  selector: 'app-update-sub-task-details',
  templateUrl: './update-sub-task-details.component.html',
  styleUrls: ['./update-sub-task-details.component.scss']
})
export class UpdateSubTaskDetailsComponent implements OnInit {

  @Output()
  subTaskPanelToggleEvent: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(StepTaskAllocationComponent) stepTaskAllocationComponent: StepTaskAllocationComponent;

  subtaskForm: NgForm;
  disabledControls: boolean = false;
  isOutsideImagility: boolean = true;

  attorneyPreparerEmployeeList: any; // Attorney company users list
  serviceCenterList: ServiceCenterDetails[];
  signatoryEmployeeList: SignatoryDetails[];
  attorneyFirmList: Array<{ attorneyId: number; attorneyName: string; }>;
  petitionerPreparerEmployeeList: any;
  task: SubTaskDetails;
  userType : string;
  index = 0;
  taskAllocationId = 0;

  observableSubscription$ = new Subject();
  overviewSubTaskData: any;

  constructor(
    private lookupService: LookupService,
    private pbService: PetitionBuilderService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    public customQuestionnaireService: CustomQuestionnaireService,
    private store: Store<any>) {
    this.attorneyPreparerEmployeeList = [];
    this.serviceCenterList = [];
    this.signatoryEmployeeList = [];
    this.attorneyFirmList = [];
    this.petitionerPreparerEmployeeList = [];
    this.userType = sessionStorage.getItem('userTypeRole');
  }

  ngOnInit() {
    if (this.userType === 'Beneficiary') {
      this.disabledControls = true;
    }
    // Get Sub task Details
    this.store.pipe(select(getSubTaskDetails)).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTaskDetails) => {
      data.taskCustomStepDetails = this.customQuestionnaireService.masterData?.customStepList;
      this.task = data;
      if (this.task.serviceCenterDetails) {
        this.getServiceCenter(this.task.serviceCenterDetails.isPremiumCenter);
      }
      this.getSignatoryName();
      this.getActiveAttorneyFirmList();
      this.getPetitionerPreparer();
      if (this.task.attorneyId > 0) {
        this.onAttorneyFirmChange();
      }
    });
    if (this.task && this.task.id) {
      let submitPetitionStepDetails = this.task.taskStepDetails.find(x => x.stepActionList[0].layoutCode === 'SUB_I140_PET');
      if (submitPetitionStepDetails && submitPetitionStepDetails.stepStatusDetails && submitPetitionStepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE') {
        this.disabledControls = true;
      }
    }
  }

  onChangeProcessingType(processingType: number) {
    this.serviceCenterList = [];
    this.getServiceCenter(processingType);
  }

  // This code is neccessary
  onAttorneyPreparerChange({ value }) {
    this.task.preparerAttorneyName = this.attorneyPreparerEmployeeList.find(x => x['id'] === value)['firstName'] + ' ' + this.attorneyPreparerEmployeeList.find(x => x.id === value)['lastName']
  }

  onPetitionerPreparerChange({ value }) {
    this.task.preparePetitionerName = this.petitionerPreparerEmployeeList.find(x => x['id'] === value)['firstName'] + ' ' + this.petitionerPreparerEmployeeList.find(x => x.id === value)['lastName']
  }

  // Fetch active attorney list associated with company
  getActiveAttorneyFirmList() {
    this.lookupService.getActiveAttorneyCompanyList(this.task.companyId).pipe(takeUntil(this.observableSubscription$)).subscribe((data: Array<{ attorneyId: number; attorneyName: string; }>) => {
      this.attorneyFirmList = Object.assign([],[{attorneyId:null, attorneyName:"Select attorney"},...data]);
    });
  }

  getServiceCenter(processingType: number) {    
    this.lookupService.getServiceCentersImmigrant((processingType === 0) ? 'false' : 'true').pipe(takeUntil(this.observableSubscription$)).subscribe((data: ServiceCenterDetails[]) => {
      this.serviceCenterList = data;
    });
  }

  getSignatoryName() {
    this.lookupService.getReviewersUser(this.task.companyId, USER_PERMISSIONS.PETITION_REVIEWER).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SignatoryDetails[]) => {
      this.signatoryEmployeeList = data;
    });
  }

  getPetitionerPreparer() {
    this.lookupService.getUsersOfCompany(this.task.companyId).pipe(takeUntil(this.observableSubscription$)).subscribe((data: Array<any>) => {
      this.petitionerPreparerEmployeeList = data;
    });
  }

  onAttorneyFirmChange() {
    // get users of the selected attorney firm
    this.lookupService.getUsersOfCompany(this.task.attorneyId).pipe(takeUntil(this.observableSubscription$)).subscribe((data: Array<any>) => {
      this.attorneyPreparerEmployeeList = data;
    });

  }

  onSignatoryChange({ value }) {
    this.task.signatoryDetails = this.signatoryEmployeeList.find(x => x.id === value);
  }

  handleChange(e) {
    this.index = e.index;
    const queryParamsObj = {
      taskAllocationId: this.taskAllocationId || 0
    };
    if (this.index === 0) {
      this.router.navigate(['./'], { queryParams: queryParamsObj, relativeTo: this.route });
    } else {
      this.router.navigate(['./'], { queryParams: queryParamsObj, relativeTo: this.route });
    }
  }

  stepStepTime() {
    this.index = 1;
    if(this.stepTaskAllocationComponent){
      this.stepTaskAllocationComponent.ngOnInit();
    }
  }

  postSubTask() {
    const subtaskForm = {
      attorneyId: this.task.attorneyId,
      authorizedSignatoryId: this.task.signatoryId,
      immSpecialistId: this.task.immSpecialistId,
      preparerAttorneyId: this.task.preparerAttorneyId,
      serviceCenterId: this.task.serviceCenterDetails?.id,
      taskId: this.task.id,
      stepList: this.stepTaskAllocationComponent.stepTaskTimelineList,
      customStepList: this.stepTaskAllocationComponent.customStepTaskTimelineList
    }
    if (this.stepTaskAllocationComponent.customStepTaskTimelineList.length) {
    this.customQuestionnaireService.getSuperTask(this.task.superTaskId)
        .pipe(takeUntil(this.observableSubscription$))
        .subscribe((data: any) => {
          this.overviewSubTaskData = data;
          if (data.subTaskList[0].customStepOverviewList !== null) {
            this.customQuestionnaireService.masterData.customStepList.forEach(element => {
              let isAllocatedStep = data[0].customStepOverviewList.find(a => a.stepId === element.id);
              if (isAllocatedStep) {
                let updateStepData = subtaskForm.customStepList.find(u => u.id === isAllocatedStep.stepId)
                updateStepData.taskStepId = isAllocatedStep.id;
                updateStepData.id = element.id;
              }
            });
          }
          this.saveUpdateSubTask(subtaskForm);
        });
      }else{
        this.saveUpdateSubTask(subtaskForm);
      }
    }
    saveUpdateSubTask(subtaskForm) {
    this.pbService.saveUpdateSubTask(subtaskForm).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      this.toastr.success(response.message, 'Success');
      this.store.dispatch(loadSubTaskDetails({ taskId: this.task.id }));
    });
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handleSubTaskPanelToggle() {
    this.subTaskPanelToggleEvent.emit(false);
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }
}
